"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _colors = _interopRequireDefault(require("../../colors"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _RadioButton = _interopRequireDefault(require("./RadioButton.styled"));

var _excluded = ["label", "id", "disabled", "primaryColor", "checked", "name", "value", "automationId", "className"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var RadioButton = _react["default"].forwardRef(function (_ref, ref) {
  var label = _ref.label,
      id = _ref.id,
      disabled = _ref.disabled,
      _ref$primaryColor = _ref.primaryColor,
      primaryColor = _ref$primaryColor === void 0 ? _colors["default"].primary.claytonBlue : _ref$primaryColor,
      checked = _ref.checked,
      name = _ref.name,
      value = _ref.value,
      automationId = _ref.automationId,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  var propertyClasses = [];
  var radioRef = ref || (0, _react.useRef)();
  var labelRef = (0, _react.useRef)();
  propertyClasses.push(primaryColor.className);
  propertyClasses.push(disabled ? 'disabled' : '');
  return _react["default"].createElement(_RadioButton["default"], {
    className: className + ' ' + propertyClasses.join(" ")
  }, _react["default"].createElement("label", {
    ref: labelRef,
    htmlFor: id,
    tabIndex: "0",
    onKeyDown: function onKeyDown(e) {
      if (e.keyCode === 13 || e.keyCode === 32) {
        if (radioRef.current) {
          radioRef.current.checked = true;
        } //forceUpdate();


        if (props.onChange) {
          props.onChange({
            target: radioRef.current
          });
        }

        e.preventDefault();
        e.stopPropagation();
      }
    }
  }, _react["default"].createElement("input", _extends({
    ref: radioRef,
    tabIndex: "-1",
    onFocus: function onFocus() {
      return labelRef.current.focus();
    },
    disabled: disabled,
    className: "form-radio",
    id: id,
    name: name,
    "data-test-id": automationId || null,
    type: "radio",
    value: value,
    checked: checked
  }, props)), _react["default"].createElement("span", null, label)));
});

RadioButton.defaultProps = {
  label: "",
  id: "",
  disabled: false,
  checked: false,
  name: "",
  value: "",
  automationId: "",
  className: ""
};
RadioButton.props = {
  label: _propTypes["default"].string,
  id: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  checked: _propTypes["default"].bool,
  name: _propTypes["default"].string,
  value: _propTypes["default"].string,
  automationId: _propTypes["default"].string,
  className: _propTypes["default"].string
};
var _default = RadioButton;
exports["default"] = _default;